import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tempus/component-library/utils/withStyles';
import { HeroButton } from '@tcl-boron-prefabs/hero-button';
import styles from './styles';
import { HubLogo } from './Logos/TempusLogoHub';
import { LensLogo } from './Logos/TempusLogoLens';
import { PixelRadLogo } from './Logos/TempusLogoPixelRad';
import { TherapiesSitesLogo } from './Logos/TempusLogoTherapiesSites';
import { TherapiesSponsorsLogo } from './Logos/TempusLogoTherapiesSponsors';
import { ApplicationNames } from '../../app-config/shared';

const renderTempusLogoWithApp = (appName) => {
  switch (appName) {
    case ApplicationNames.HUB:
      return <HubLogo />;
    case ApplicationNames.LENS:
      return <LensLogo />;
    case ApplicationNames.PIXEL_RAD:
      return <PixelRadLogo />;
    case ApplicationNames.THERAPIES_SITES:
      return <TherapiesSitesLogo />;
    case ApplicationNames.THERAPIES_SPONSORS:
      return <TherapiesSponsorsLogo />;
    case ApplicationNames.DAVID:
      return <HubLogo />; // TBD on the David logo
    default:
      return null;
  }
};

const ApplicationCard = ({ classes, onClick, application }) => (
  <div className={classes.container} data-testid={`app-card`}>
    <HeroButton logo={renderTempusLogoWithApp(application)} onClick={onClick} ariaLabel={application} />
  </div>
);

ApplicationCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  application: PropTypes.string.isRequired,
};

export default withStyles(styles)(ApplicationCard);
